import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import PageWrapper from "../../components/common/layout/PageWrapper";
import BiblioReferenceNew from "../../components/services/bibliographicReference/BiblioReferenceNew";

const BiblioReferenceNewPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.new`)}>
      <BiblioReferenceNew />
    </PageWrapper>
  );
};
export default BiblioReferenceNewPage;
